<template>
    <div :id="recaptchaId" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { randomString } from '~/composables/support/util'

const recaptchaId = 'rphq_recaptcha_' + randomString()
const widgetId = ref<number | null>(null)

const emit = defineEmits<{
    (e: 'token', payload: string): void
}>()

onMounted(() => {
    widgetId.value = window.grecaptcha.render(recaptchaId, {
        sitekey: '6LeOcIUpAAAAACW5tY8Vb0jCdA0P64c4EqwS7KLD',
        callback: (token: string) => {
            emit('token', token)
        },
        'expired-callback': () => {
            emit('token', '')
        },
        theme: 'light'
    })
})

function reset() {
    // Google v2 tokens are single-use; reset lets checkout recover after
    // validation or payment errors without requiring a full page refresh.
    if (widgetId.value !== null) {
        window.grecaptcha.reset(widgetId.value)
        emit('token', '')
    }
}

defineExpose({ reset })
</script>
